interface ActiveFieldProps {
  field: any;
}
const hiddenFields = ['136', '137', '138', '139'];

const ActiveField: React.FC<ActiveFieldProps> = ({
  field: { field, fieldOptions }
}) => (
  <div
    style={{
      display: hiddenFields.includes(field?.id) ? 'none' : 'flex',
      flexDirection: 'column',
      margin: '0 4px',
      marginBottom: 16,
      textAlign: 'left'
    }}
  >
    {/* <label
      style={{
        display: 'block',
        color: '#64728C',
        fontFamily: 'Montserrat',
        fontSize: 14,
        fontWeight: 600,
        marginBottom: 6
      }}
      htmlFor={field.perstag}
    >
      {field.title} {field.isrequired !== '0' && '*'}
    </label> */}
    {(() => {
      switch (field.type) {
        case 'text': {
          return (
            <input
              placeholder={field.title}
              required={field.isrequired !== '0'}
              data-default={field.isDefault}
              type={field.inputType}
              style={{
                background: '#FFFFFF',
                border: '1px solid #E8EAEF',
                borderRadius: 100,
                padding: '8.5px 15px',
                height: 20
              }}
              name={field.perstag}
              data-id={field.id}
            />
          );
        }

        case 'dropdown': {
          return (
            <select
              required={field.isrequired !== '0'}
              data-default={field.isDefault}
              style={{
                background: '#FFFFFF',
                border: '1px solid #E8EAEF',
                borderRadius: 5,
                padding: '8.5px 15px',
                height: 40
              }}
              name={field.perstag}
              data-id={field.id}
            >
              <option hidden disabled selected value={null}>Selecione uma opção</option>
              {fieldOptions.map((option) => (
                <option key={option.id} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          );
        }

        case 'textarea': {
          return (
            <textarea
              placeholder={field.title}
              required={field.isrequired !== '0'}
              data-default={field.isDefault}
              style={{
                background: '#FFFFFF',
                border: '1px solid #E8EAEF',
                borderRadius: 5,
                padding: '8.5px 15px',
                height: 20
              }}
              name={field.perstag}
              data-id={field.id}
            />
          );
        }

        case 'checkbox': {
          return (
            fieldOptions.map(option => (
              <div key={option.id} style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: 14,
              }}>
                <input
                  placeholder={field.title}
                  type="checkbox"
                  data-default={option.isDefault}
                  style={{
                    background: '#FFFFFF',
                    border: '1px solid #E8EAEF',
                    borderRadius: 5,
                    padding: '8.5px 15px',
                    height: 20,
                  }}
                  data-id={option.id}
                  data-field={option.field}
                  value={option.value}
                  name={option.value}
                  required={field.isrequired !== '0'}
                />
                <label
                  style={{
                    marginLeft: 6
                  }}
                  htmlFor={option.name}>
                  {option.label}
                </label>
              </div>
            ))
          )
        }

        default:
          return null;
      }
    })()}
  </div>
);
export default ActiveField;
